module.exports = __webpack_public_path__ + "static/media/N2.24b0d2c1.png";